import script from "./file-preview-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./file-preview-modal.vue?vue&type=script&setup=true&lang=js"

import "./file-preview-modal.vue?vue&type=style&index=0&id=3228d27c&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3228d27c"]])

export default __exports__